import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ScratchpadHistoryComponent } from './scratchpad-history-component';
import './scratchpad.css';

interface ScratchpadHistoryModalProps {
  isOpen: boolean;
  onDidDismiss: () => void;
  presentingEl?: HTMLElement;
}

const ScratchpadHistoryModal = (
  props: ScratchpadHistoryModalProps
): ReactElement => {
  const { isOpen, onDidDismiss } = props;
  const { i18n } = useTranslation();

  return (
    <IonModal
      id="scratchpad-history-modal"
      presentingElement={props.presentingEl}
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
      canDismiss={true}
      backdropDismiss={false}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={onDidDismiss}>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{i18n.t('common:scratchpad_version_history')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <ScratchpadHistoryComponent closePresentingElement={onDidDismiss} />
      </IonContent>
    </IonModal>
  );
};

export { ScratchpadHistoryModal };
